import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { AuthShell, Field, FormError } from "./AuthShell";
import { api, formatApiError } from "../../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? "" : "This reset link is missing its token. Please request a new one.");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="New password" subtitle="Choose a new password for your account." testid="reset-page">
      <title>Reset password | Vata Infrastructures</title>
      {done ? (
        <div data-testid="reset-success" className="border-l-4 border-[var(--forest)] bg-white p-5">
          <CheckCircle2 className="h-6 w-6 text-[var(--forest)]" />
          <p className="mt-3 font-semibold">Password updated</p>
          <Link to="/login" data-testid="reset-login-link" className="btn-rust mt-4 inline-block px-6 py-3">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <Field id="rp-pass" label="New password (min 8)" type="password" minLength={8} autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" />
          <Field id="rp-confirm" label="Confirm new password" type="password" minLength={8} autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" />
          <FormError error={error} />
          <button type="submit" disabled={busy || !token} data-testid="reset-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-4 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Save new password
          </button>
          <p className="text-sm"><Link to="/forgot-password" className="font-semibold underline">Request a new link</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
